React = require 'react'
t = require('views/internal/recup-with-helpers')('bc_info')

module.exports = class extends React.Component
  displayName: 'BC3UpgradeContactUsComponent'

  render: t.renderable ->
    t.div '.business-class-upgrade-box.u-gutter', ->
      t.p ->
        t.format 'contact us to upgrade'

      t.p '.business-class-upgrade-box-header', ->
        t.format 'contact options', phoneNumber: '1 (844) 873-5561', emailAddress: 'sales@trello.com'



// WEBPACK FOOTER //
// ./app/scripts/views/organization/bc3-upgrade-contact-us-component.coffee